import React from 'react';
import { Target, Info } from 'lucide-react';

const GoalSettingSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  weightGoals
}) => {
  if (!formData) return null;

  return (
    <div className="mb-6 bg-emerald-50 dark:bg-emerald-900/20 p-4 rounded-lg border border-emerald-200 dark:border-emerald-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Target className="w-5 h-5 mr-2 text-emerald-500" />
        Цель по весу
      </h3>
      
      <div className="grid grid-cols-1 gap-4">
        {/* Выбор цели */}
        <div>
          <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
            Ваша цель
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {weightGoals.map((goal) => (
              <label 
                key={goal.id}
                className={`
                  relative border rounded-lg p-4 cursor-pointer transition-colors
                  ${formData.goal === goal.id 
                    ? 'bg-emerald-100 border-emerald-400 dark:bg-emerald-900/40 dark:border-emerald-600' 
                    : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-750'
                  }
                `}
              >
                <input
                  type="radio"
                  name="goal"
                  value={goal.id}
                  checked={formData.goal === goal.id}
                  onChange={handleInputChange}
                  className="sr-only"
                />
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-gray-900 dark:text-white">
                    {goal.name}
                  </span>
                  <span className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                    {goal.description}
                  </span>
                </div>
                <div className={`absolute top-3 right-3 h-3 w-3 rounded-full ${
                  formData.goal === goal.id ? 'bg-emerald-500' : 'bg-gray-200 dark:bg-gray-600'
                }`}></div>
              </label>
            ))}
          </div>
          {errors.goal && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.goal}
            </p>
          )}
        </div>

        {/* Информация в зависимости от выбранной цели */}
        <div className="mt-2">
          {formData.goal === 'lose' && (
            <div className="flex items-start p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg border border-amber-100 dark:border-amber-800">
              <Info className="w-5 h-5 text-amber-500 mr-3 mt-0.5 flex-shrink-0" />
              <div>
                <h4 className="text-sm font-medium text-amber-800 dark:text-amber-300">Рекомендации по снижению веса</h4>
                <p className="text-xs text-amber-700 dark:text-amber-400 mt-1">
                  Здоровое снижение веса составляет 0,5-1 кг в неделю. Более быстрая потеря веса 
                  может быть вредной для здоровья. По рекомендациям Минздрава РФ, для здорового 
                  снижения веса следует создать дефицит 500-1000 ккал в день за счет питания и физической активности.
                </p>
              </div>
            </div>
          )}

          {formData.goal === 'maintain' && (
            <div className="flex items-start p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800">
              <Info className="w-5 h-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" />
              <div>
                <h4 className="text-sm font-medium text-blue-800 dark:text-blue-300">Поддержание здорового веса</h4>
                <p className="text-xs text-blue-700 dark:text-blue-400 mt-1">
                  Для поддержания веса важно создать баланс между потребляемыми и расходуемыми калориями. 
                  По данным Российского общества профилактики неинфекционных заболеваний, регулярная физическая 
                  активность (150 минут умеренной или 75 минут интенсивной в неделю) и сбалансированное питание 
                  помогают сохранить достигнутый результат.
                </p>
              </div>
            </div>
          )}

          {formData.goal === 'gain' && (
            <div className="flex items-start p-3 bg-violet-50 dark:bg-violet-900/20 rounded-lg border border-violet-100 dark:border-violet-800">
              <Info className="w-5 h-5 text-violet-500 mr-3 mt-0.5 flex-shrink-0" />
              <div>
                <h4 className="text-sm font-medium text-violet-800 dark:text-violet-300">Рекомендации по набору веса</h4>
                <p className="text-xs text-violet-700 dark:text-violet-400 mt-1">
                  Для здорового набора веса рекомендуется увеличить калорийность рациона на 300-500 ккал 
                  в день выше уровня поддержания. Включите в рацион больше белка (1,6-2,2 г на кг веса) 
                  и занимайтесь силовыми тренировками для роста мышечной массы, а не жировой ткани.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GoalSettingSection;